import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { EmptyCard } from 'components';

export default ({ children }) => (
  <Switch>
    {children}
    <Route component={EmptyCard.PageNotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/pages/__components__/Switch.js